import nopicture from "../assets/nopicture.png";
import { getBackendUrl } from "../config";

export const resolveContactAvatar = (contact) => {
  try {
    const rawUrl = contact?.urlPicture || contact?.profilePicUrl || "";
    if (typeof rawUrl === "string" && rawUrl.trim() !== "") {
      const trimmed = rawUrl.trim();
      const publicIndex = trimmed.indexOf("/public/");
      if (publicIndex !== -1) {
        const backendBase = (getBackendUrl() || "").replace(/\/+$/, "");
        const pathPart = trimmed.slice(publicIndex);
        return `${backendBase}${pathPart}`;
      }
      return trimmed;
    }
  } catch (e) {
    // noop
  }
  return nopicture;
};

export const hasCustomAvatar = (contact) => {
  const url = resolveContactAvatar(contact);
  if (!url) return false;
  // nopicture importado como asset bundled - comparar pela referência
  return url !== nopicture && !url.includes("nopicture");
};

export const resolveTicketContactAvatar = (ticket) => {
  return resolveContactAvatar(ticket?.contact);
};
